/* eslint-disable max-len */
import { MainDashboardInterface } from '.';

export const defaultMacrosListVast: MainDashboardInterface.IVastMacros[] = [
  {
    id: '[PAGE_URL]',
    name: '[PAGE_URL]',
    mobile_web: true,
    desktop: true,
    mobile_app: false,
    ctv: false,
    desc: 'URL of the page where the impression will be shown'
  },
  { id: '[DOMAIN]', name: '[DOMAIN]', mobile_web: true, desktop: true, mobile_app: false, ctv: false, desc: 'domain of the site' },
  { id: '[DNT]', name: '[DNT]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'do not track' },
  { id: '[LOCATION_LON]', name: '[LOCATION_LON]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'longitude from -180.0 to +180.0' },
  { id: '[LOCATION_LAT]', name: '[LOCATION_LAT]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'latitude from -90.0 to +90.0' },
  { id: '[CATEGORY]', name: '[CATEGORY]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'IAB category' },
  {
    id: '[REF_URL]',
    name: '[REF_URL]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'referrer URL that caused navigation to the current page'
  },
  { id: '[APP_BUNDLE]', name: '[APP_BUNDLE]', mobile_web: false, desktop: false, mobile_app: true, ctv: true, desc: 'bundle' },
  { id: '[STORE_URL]', name: '[STORE_URL]', mobile_web: false, desktop: false, mobile_app: true, ctv: false, desc: 'app page in store' },
  { id: '[DEVICE_MAKE]', name: '[DEVICE_MAKE]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'device producer' },
  { id: '[DEVICE_MODEL]', name: '[DEVICE_MODEL]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'device model' },
  { id: '[OSV]', name: '[OSV]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'operating system versions' },
  { id: '[DEVICE_TYPE]', name: '[DEVICE_TYPE]', mobile_web: true, desktop: false, mobile_app: false, ctv: true, desc: 'device type' },
  {
    id: '[CCPA]',
    name: '[CCPA]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'CCPA field. Required for requests from California, USA'
  },
  { id: '[GDPR]', name: '[GDPR]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Required for requests from Europe. Default 0' },
  { id: '[API]', name: '[API]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Framework Api Versions' },
  { id: '[IFA]', name: '[IFA]', mobile_web: true, desktop: false, mobile_app: true, ctv: true, desc: 'unique device identifier' },
  { id: '[CARRIER]', name: '[CARRIER]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Carrier - Cell carrier' },
  {
    id: '[MAX_DURATION]',
    name: '[MAX_DURATION]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'Maxduration -Maximum video ad duration in seconds'
  },
  {
    id: '[MIN_DURATION]',
    name: '[MIN_DURATION]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'Minduration - Minimum video ad duration in seconds'
  },
  { id: '[PLAYER_WIDTH]', name: '[PLAYER_WIDTH]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Player width' },
  { id: '[PLAYER_HEIGHT]', name: '[PLAYER_HEIGHT]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Player height' },
  {
    id: '[GDPR_CONSENT]',
    name: '[GDPR_CONSENT]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'Consent string in accordance with GDPR framework'
  },
  { id: '[PID]', name: '[PID]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Publisher ID' },
  { id: '[APP_NAME]', name: '[APP_NAME]', mobile_web: false, desktop: false, mobile_app: true, ctv: true, desc: 'App name' },
  { id: '[BIDFLOOR]', name: '[BIDFLOOR]', mobile_web: false, desktop: false, mobile_app: false, ctv: false, desc: 'The minimal bidfloor for the request' },
  { id: '[OS]', name: '[OS]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'device operation system' },
  { id: '[SCHAIN]', name: '[SCHAIN]', mobile_web: true, desktop: true, mobile_app: true, ctv: true, desc: 'Supply Chain' },
  { id: '[APP_VERSION]', name: '[APP_VERSION]', mobile_web: false, desktop: false, mobile_app: false, ctv: false, desc: 'Application version' },
  {
    id: '[BUYER_UID]',
    name: '[BUYER_UID]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Buyer-specific ID (cookie id) for the user as mapped by the exchange for the buyer'
  },
  {
    id: '[CONTENT_CONTEXT]',
    name: '[CONTENT_CONTEXT]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Type of content (game, video, text, etc.)'
  },
  {
    id: '[CONTENT_EPISODE]',
    name: '[CONTENT_EPISODE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Episode number'
  },
  {
    id: '[CONTENT_GENRE]',
    name: '[CONTENT_GENRE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Genre that best describes the content (e.g., rock, pop, etc)'
  },
  {
    id: '[CONTENT_KEYWORDS]',
    name: '[CONTENT_KEYWORDS]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Comma separated list of keywords describing the content'
  },
  {
    id: '[CONTENT_LENGTH]',
    name: '[CONTENT_LENGTH]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Length of content in seconds; appropriate for video or audio'
  },
  {
    id: '[CONTENT_PRODQUALITY]',
    name: '[CONTENT_PRODQUALITY]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Production quality'
  },
  {
    id: '[CONTENT_RATING]',
    name: '[CONTENT_RATING]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content rating (e.g., MPAA)'
  },
  {
    id: '[CONTENT_SEASON]',
    name: '[CONTENT_SEASON]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content season (e.g., “Season 3”)'
  },
  {
    id: '[CONTENT_SERIES]',
    name: '[CONTENT_SERIES]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content series (e.g “The Office” (television), “Star Wars” (movie))'
  },
  {
    id: '[CONTENT_URL]',
    name: '[CONTENT_URL]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'URL of the content, for buy-side contextualization or review'
  },
  {
    id: '[CONTENT_CHANNEL]',
    name: '[CONTENT_CHANNEL]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Name of the channel an ad will be displayed on. For example: (MTV, HGTV, CNN, BBC One, Publica TV, etc)'
  },
  {
    id: '[CONTENT_ID]',
    name: '[CONTENT_ID]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'ID uniquely identifying the content'
  },
  {
    id: '[COPPA]',
    name: '[COPPA]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'Flag indicating if this request is subject to the COPPA regulations established by the USA FTC, where 0 = no, 1 = yes'
  },
  {
    id: '[IFA_TYPE]',
    name: '[IFA_TYPE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'The types of IFA are Device, Publisher (including apps), SSP and Session'
  },
  {
    id: '[LANGUAGE]',
    name: '[LANGUAGE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content language using ISO-639-1-alpha-2'
  },
  {
    id: '[PLACEMENT_ID]',
    name: '[PLACEMENT_ID]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Identifier for specific ad placement or ad tag that was used to initiate the auction'
  },
  {
    id: '[TITLE]',
    name: '[TITLE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content title'
  },
  {
    id: '[USER_ID]',
    name: '[USER_ID]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'The user id (cookie id) in the supplier\'s system'
  },
  {
    id: '[GPP]',
    name: '[GPP]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Global Privacy Platform String'
  },
  {
    id: '[CCPA_CONSENT]',
    name: '[CCPA_CONSENT]',
    mobile_web: true,
    desktop: true,
    mobile_app: true,
    ctv: true,
    desc: 'CCPA regulation user consent. Highly recommended for California region'
  },
  {
    id: '[MIMES]',
    name: '[MIMES]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Content MIME types supported'
  },
  {
    id: '[REWARDED]',
    name: '[REWARDED]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Rewarded video identification, where REWARDED=1 rewarded video recognized'
  },
  {
    id: '[PLACEMENT]',
    name: '[PLACEMENT]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Various types of video placements derived largely from the IAB Digital Video Guidelines. This parameter is populated according to OpenRTB Version 2.5 standards.'
  },
  {
    id: '[PLAYBACKMETHOD]',
    name: '[PLAYBACKMETHOD]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Various media playback methods. This parameter is populated according to OpenRTB Version 2.5 standards.'
  },
  {
    id: '[PLCMT]',
    name: '[PLCMT]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Various types of video placements in accordance with updated IAB Digital Video Guidelines. This parameter is populated according to OpenRTB Version 2.6 standards.'
  },
  {
    id: '[LINEARITY]',
    name: '[LINEARITY]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Options for video linearity'
  },
  {
    id: '[PROTOCOLS]',
    name: '[PROTOCOLS]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Array of supported video bid response protocols. Please refer to Sec 4.20 Audio Bid Response Protocols for a list of possible values. At least one supported protocol must be specified in the protocols attribute.'
  },
  {
    id: '[STARTDELAY]',
    name: '[STARTDELAY]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Indicates the start delay in seconds for pre-roll, mid-roll, or post-roll audio ad placements.',
  },
  {
    id: '[COMPANIONTYPE]',
    name: '[COMPANIONTYPE]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Recommended if companion objects are included. See OpenRTB 2.4 Table 5.12 VAST Companion Types for a list of possible values.',
  },
  {
    id: '[FEED]',
    name: '[FEED]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Type of audio feed. Refer to List: Feed Types in AdCOM 1.0.',
  },
  {
    id: '[LMT]',
    name: '[LMT]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Limit Ad Tracking – an opt-out to respect the users’ privacy choices.',
  },
  {
    id: '[DEALID]',
    name: '[DEALID]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: `Reference to the deal.id value expected in the macro, which should be passed as the deal.id value in the PMR deal object within the RTB request repackaged from the received VAST request.
    Used when the bid pertains to a private marketplace direct deal.`,
  },
  {
    id: '[POSITION]',
    name: '[POSITION]',
    mobile_web: false,
    desktop: false,
    mobile_app: false,
    ctv: false,
    desc: 'Ad position on the page layout',
  },
];

export const defaultMacrosListVastDSP: MainDashboardInterface.IVastMacrosDSP[] = [
  {
    id: '[PAGE_URL]',
    name: '[PAGE_URL]',
    mobileWeb: true,
    desktop: true,
    inApp: false,
    ctv: false,
    desc: 'URL of the page where the impression will be shown'
  },
  { id: '[DOMAIN]', name: '[DOMAIN]', mobileWeb: true, desktop: true, inApp: false, ctv: false, desc: 'domain of the site' },
  { id: '[DNT]', name: '[DNT]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'do not track' },
  { id: '[LOCATION_LON]', name: '[LOCATION_LON]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'longitude from -180.0 to +180.0' },
  { id: '[LOCATION_LAT]', name: '[LOCATION_LAT]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'latitude from -90.0 to +90.0' },
  { id: '[CATEGORY]', name: '[CATEGORY]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'IAB category' },
  {
    id: '[REF_URL]',
    name: '[REF_URL]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'referrer URL that caused navigation to the current page'
  },
  { id: '[APP_BUNDLE]', name: '[APP_BUNDLE]', mobileWeb: false, desktop: false, inApp: true, ctv: true, desc: 'bundle' },
  { id: '[STORE_URL]', name: '[STORE_URL]', mobileWeb: false, desktop: false, inApp: true, ctv: false, desc: 'app page in store' },
  { id: '[DEVICE_MAKE]', name: '[DEVICE_MAKE]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'device producer' },
  { id: '[DEVICE_MODEL]', name: '[DEVICE_MODEL]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'device model' },
  { id: '[OSV]', name: '[OSV]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'operating system versions' },
  { id: '[DEVICE_TYPE]', name: '[DEVICE_TYPE]', mobileWeb: true, desktop: false, inApp: false, ctv: true, desc: 'device type' },
  {
    id: '[CCPA]',
    name: '[CCPA]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'CCPA field. Required for requests from California, USA'
  },
  { id: '[GDPR]', name: '[GDPR]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Required for requests from Europe. Default 0' },
  { id: '[API]', name: '[API]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Framework Api Versions' },
  { id: '[IFA]', name: '[IFA]', mobileWeb: true, desktop: false, inApp: true, ctv: true, desc: 'unique device identifier' },
  { id: '[CARRIER]', name: '[CARRIER]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Carrier - Cell carrier' },
  {
    id: '[MAX_DURATION]',
    name: '[MAX_DURATION]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'Maxduration -Maximum video ad duration in seconds'
  },
  {
    id: '[MIN_DURATION]',
    name: '[MIN_DURATION]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'Minduration - Minimum video ad duration in seconds'
  },
  { id: '[PLAYER_WIDTH]', name: '[PLAYER_WIDTH]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Player width' },
  { id: '[PLAYER_HEIGHT]', name: '[PLAYER_HEIGHT]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Player height' },
  {
    id: '[GDPR_CONSENT]',
    name: '[GDPR_CONSENT]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'Consent string in accordance with GDPR framework'
  },
  { id: '[PID]', name: '[PID]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Publisher ID' },
  { id: '[APP_NAME]', name: '[APP_NAME]', mobileWeb: false, desktop: false, inApp: true, ctv: true, desc: 'App name' },
  { id: '[BIDFLOOR]', name: '[BIDFLOOR]', mobileWeb: false, desktop: false, inApp: false, ctv: false, desc: 'The minimal bidfloor for the request' },
  { id: '[OS]', name: '[OS]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'device operation system' },
  { id: '[SCHAIN]', name: '[SCHAIN]', mobileWeb: true, desktop: true, inApp: true, ctv: true, desc: 'Supply Chain' },
  { id: '[APP_VERSION]', name: '[APP_VERSION]', mobileWeb: false, desktop: false, inApp: false, ctv: false, desc: 'Application version' },
  {
    id: '[BUYER_UID]',
    name: '[BUYER_UID]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Buyer-specific ID (cookie id) for the user as mapped by the exchange for the buyer'
  },
  {
    id: '[CONTENT_CONTEXT]',
    name: '[CONTENT_CONTEXT]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Type of content (game, video, text, etc.)'
  },
  {
    id: '[CONTENT_EPISODE]',
    name: '[CONTENT_EPISODE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Episode number'
  },
  {
    id: '[CONTENT_GENRE]',
    name: '[CONTENT_GENRE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Genre that best describes the content (e.g., rock, pop, etc)'
  },
  {
    id: '[CONTENT_KEYWORDS]',
    name: '[CONTENT_KEYWORDS]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Comma separated list of keywords describing the content'
  },
  {
    id: '[CONTENT_LENGTH]',
    name: '[CONTENT_LENGTH]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Length of content in seconds; appropriate for video or audio'
  },
  {
    id: '[CONTENT_PRODQUALITY]',
    name: '[CONTENT_PRODQUALITY]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Production quality'
  },
  {
    id: '[CONTENT_RATING]',
    name: '[CONTENT_RATING]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content rating (e.g., MPAA)'
  },
  {
    id: '[CONTENT_SEASON]',
    name: '[CONTENT_SEASON]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content season (e.g., “Season 3”)'
  },
  {
    id: '[CONTENT_SERIES]',
    name: '[CONTENT_SERIES]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content series (e.g “The Office” (television), “Star Wars” (movie))'
  },
  {
    id: '[CONTENT_URL]',
    name: '[CONTENT_URL]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'URL of the content, for buy-side contextualization or review'
  },
  {
    id: '[CONTENT_CHANNEL]',
    name: '[CONTENT_CHANNEL]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Name of the channel an ad will be displayed on. For example: (MTV, HGTV, CNN, BBC One, Publica TV, etc)'
  },
  {
    id: '[CONTENT_ID]',
    name: '[CONTENT_ID]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'ID uniquely identifying the content'
  },
  {
    id: '[COPPA]',
    name: '[COPPA]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'Flag indicating if this request is subject to the COPPA regulations established by the USA FTC, where 0 = no, 1 = yes'
  },
  {
    id: '[IFA_TYPE]',
    name: '[IFA_TYPE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'The types of IFA are Device, Publisher (including apps), SSP and Session'
  },
  {
    id: '[LANGUAGE]',
    name: '[LANGUAGE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content language using ISO-639-1-alpha-2'
  },
  {
    id: '[PLACEMENT_ID]',
    name: '[PLACEMENT_ID]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Identifier for specific ad placement or ad tag that was used to initiate the auction'
  },
  {
    id: '[TITLE]',
    name: '[TITLE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content title'
  },
  {
    id: '[USER_ID]',
    name: '[USER_ID]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'The user id (cookie id) in the supplier\'s system'
  },
  {
    id: '[GPP]',
    name: '[GPP]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Global Privacy Platform String'
  },
  {
    id: '[CCPA_CONSENT]',
    name: '[CCPA_CONSENT]',
    mobileWeb: true,
    desktop: true,
    inApp: true,
    ctv: true,
    desc: 'CCPA regulation user consent. Highly recommended for California region'
  },
  {
    id: '[MIMES]',
    name: '[MIMES]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Content MIME types supported'
  },
  {
    id: '[REWARDED]',
    name: '[REWARDED]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Rewarded video identification, where REWARDED=1 rewarded video recognized'
  },
  {
    id: '[PLACEMENT]',
    name: '[PLACEMENT]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Various types of video placements derived largely from the IAB Digital Video Guidelines. This parameter is populated according to OpenRTB Version 2.5 standards.'
  },
  {
    id: '[PLAYBACKMETHOD]',
    name: '[PLAYBACKMETHOD]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Various media playback methods. This parameter is populated according to OpenRTB Version 2.5 standards.'
  },
  {
    id: '[PLCMT]',
    name: '[PLCMT]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Various types of video placements in accordance with updated IAB Digital Video Guidelines. This parameter is populated according to OpenRTB Version 2.6 standards.'
  },
  {
    id: '[LINEARITY]',
    name: '[LINEARITY]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Options for video linearity'
  },
  {
    id: '[PROTOCOLS]',
    name: '[PROTOCOLS]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Array of supported video bid response protocols. Please refer to Sec 4.20 Audio Bid Response Protocols for a list of possible values. At least one supported protocol must be specified in the protocols attribute.'
  },
  {
    id: '[STARTDELAY]',
    name: '[STARTDELAY]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Indicates the start delay in seconds for pre-roll, mid-roll, or post-roll audio ad placements.',
  },
  {
    id: '[COMPANIONTYPE]',
    name: '[COMPANIONTYPE]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Recommended if companion objects are included. See OpenRTB 2.4 Table 5.12 VAST Companion Types for a list of possible values.',
  },
  {
    id: '[FEED]',
    name: '[FEED]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Type of audio feed. Refer to List: Feed Types in AdCOM 1.0.',
  },
  {
    id: '[LMT]',
    name: '[LMT]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: 'Limit Ad Tracking – an opt-out to respect the users’ privacy choices.',
  },
  {
    id: '[DEALID]',
    name: '[DEALID]',
    mobileWeb: false,
    desktop: false,
    inApp: false,
    ctv: false,
    desc: `Reference to the deal.id value expected in the macro, which should be passed as the deal.id value in the PMR deal object within the RTB request repackaged from the received VAST request.
    Used when the bid pertains to a private marketplace direct deal.`,
  },
];


export const urlVastAttributes = {
  '[BIDFLOOR]': 'bidfloor',
  '[PAGE_URL]': 'page',
  '[DOMAIN]': 'domain',
  '[DNT]': 'dnt',
  '[LOCATION_LON]': 'lon',
  '[LOCATION_LAT]': 'lat',
  '[CATEGORY]': 'cat',
  '[REF_URL]': 'ref',
  '[APP_BUNDLE]': 'bundle',
  '[WIDTH]': 'w',
  '[HEIGHT]': 'h',
  '[IFA]': 'ifa',
  '[STORE_URL]': 'store_url',
  '[DEVICE_MAKE]': 'make',
  '[DEVICE_MODEL]': 'model',
  '[OSV]': 'osv',
  '[APP_NAME]': 'name',
  '[DEVICE_TYPE]': 'devicetype',
  '[CCPA]': 'ccpa',
  '[GDPR]': 'gdpr',
  '[API]': 'api',
  '[CARRIER]': 'carrier',
  '[MAX_DURATION]': 'maxduration',
  '[MIN_DURATION]': 'minduration',
  '[PLAYER_HEIGHT]': 'playerheight',
  '[PLAYER_WIDTH]': 'playerwidth',
  '[GDPR_CONSENT]': 'gdpr_consent',
  '[PID]': 'publisher_id',
  '[OS]': 'os',
  '[SCHAIN]': 'schain',
  '[APP_VERSION]': 'app_version',
  '[BUYER_UID]': 'buyer_uid',
  '[CONTENT_CONTEXT]': 'content_context',
  '[CONTENT_EPISODE]': 'content_episode',
  '[CONTENT_GENRE]': 'content_genre',
  '[CONTENT_KEYWORDS]': 'content_keywords',
  '[CONTENT_LENGTH]': 'content_length',
  '[CONTENT_PRODQUALITY]': 'content_prodquality',
  '[CONTENT_RATING]': 'content_rating',
  '[CONTENT_SEASON]': 'content_season',
  '[CONTENT_SERIES]': 'content_series',
  '[CONTENT_URL]': 'content_url',
  '[CONTENT_CHANNEL]': 'content_channel',
  '[CONTENT_ID]': 'content_id',
  '[COPPA]': 'coppa',
  '[IFA_TYPE]': 'ifa_type',
  '[LANGUAGE]': 'language',
  '[PLACEMENT_ID]': 'placement_id',
  '[TITLE]': 'title',
  '[USER_ID]': 'user_id',
  '[GPP]': 'gpp',
  '[CCPA_CONSENT]': 'ccpa_consent',
  '[MIMES]': 'mimes',
  '[REWARDED]': 'rewarded',
  '[PLACEMENT]': 'placement',
  '[PLAYBACKMETHOD]': 'playbackmethod',
  '[PLCMT]': 'plcmt',
  '[LINEARITY]': 'linearity',
  '[PROTOCOLS]': 'protocols',
  '[STARTDELAY]': 'startdelay',
  '[COMPANIONTYPE]': 'companiontype',
  '[FEED]': 'feed',
  '[LMT]': 'lmt',
  '[DEALID]': 'dealid',
  '[POSITION]': 'position',
};


export const macrosListJsDSP: { id: string, name: string, desc: string, param?: string }[] = [
  { id: '[IP]', name: '[IP]', desc: 'IPv4 address closest to device' },
  { id: '[UA]', name: '[UA]', desc: 'Browser user agent string' },
  { id: '[DOMAIN]', name: '[DOMAIN]', desc: 'Domain of the site (e.g., "mysite.foo.com"). Mandatory for Web traffic' },
  {
    id: '[APP_BUNDLE]',
    name: '[APP_BUNDLE]',
    desc: `A platform-specific application identifier intended to be unique to the app and independent of the exchange.
    On Android, this should be a bundle or package name (e.g.,com.foo.mygame).
    On iOS, it is typically a numeric ID. Mandatory for InApp traffic.`,
  },
  { id: '[STORE_URL]', name: '[STORE_URL]', desc: 'App store URL for an installed app' },
  { id: '[PAGE_URL]', name: '[PAGE_URL]', desc: 'URL of the page where the impression will be shown. Mandatory for Web traffic' },
  { id: '[APP_NAME]', name: '[APP_NAME]', desc: 'App name' },
  { id: '[WIDTH]', name: '[WIDTH]', desc: 'ADM width' },
  { id: '[HEIGHT]', name: '[HEIGHT]', desc: 'ADM height' },
  { id: '[DEVICE_W]', name: '[DEVICE_W]', desc: 'Device width (optional)' },
  { id: '[DEVICE_H]', name: '[DEVICE_H]', desc: 'Device height (optional)' },
  { id: '[LOCATION_LAT]', name: '[LOCATION_LAT]', desc: 'Latitude from -90.0 to +90.0, where negative is south. If empty default - ip location' },
  { id: '[LOCATION_LON]', name: '[LOCATION_LON]', desc: 'Longitude from -180.0 to +180.0, where negative is west. If empty default - ip location' },
  { id: '[BIDFLOOR]', name: '[BIDFLOOR]', desc: 'Bidfloor (optional) if empty default - SSP config bidfloor' },
  {
    id: '[COPPA]',
    name: '[COPPA]',
    desc: 'A flag indicating traffic that is subject to the Children\'s Online Privacy Protection Act of the United States',
  },
  { id: '[GDPR_CONSENT]', name: '[GDPR_CONSENT]', desc: 'GDPR regulation user consent (optional) Highly recommended for GDPR region' },
  {
    id: '[CCPA_CONSENT]',
    name: '[CCPA_CONSENT]',
    desc: 'CCPA regulation user consent (optional) Highly recommended for California region',
  },
  { id: '[CATEGORY]', name: '[CATEGORY]', desc: 'IAB site content categories' },
  {
    id: '[DNT]',
    name: '[DNT]',
    desc: 'Standard "Do Not Track" flag as set in the header by the browser, where 0 = tracking is unrestricted, 1 = do not track'
  },
  { id: '[CB]', name: '[CB]', desc: 'Random number to prevent caching' },
  { id: '[SCHAIN]', name: '[SCHAIN]', desc: 'Supply Chain object information' },
  { id: '[IFA]', name: '[IFA]', desc: 'ID sanctioned for advertiser use in the clear (i.e., not hashed). Mandatory for InApp traffic' },
  {
    id: '[GDPR]',
    name: '[GDPR]',
    desc: 'The parameter states the fact of GDPR compliance of the source. If the parameter gdpr is not present or the value is not valid the server will check the GDPR compliance nevertheless. The server will do a lookup of the users IP address to see if user is from EU or not'
  },
  { id: '[SCHAIN]', name: '[SCHAIN]', desc: 'Supply Chain' },
  { id: '[USER_ID]', name: '[USER_ID]', desc: 'The user id (cookie id) in the supplier\'s system' },
  {
    id: '[DESCRIPTION_URL]',
    name: '[DESCRIPTION_URL]',
    desc: 'This macro should be used for Google Ad Manager DSP and Web traffic only. This parameter states the page with the video player, but could also be a page with text that describes the video.e.g URL-encoded: description_url=http%3A%2F%2Fchapmanganato.com'
  },
  { id: '[APP_VERSION]', name: '[APP_VERSION]', desc: 'Application version' },
  { id: '[BUYER_UID]', name: '[BUYER_UID]', desc: 'Buyer-specific ID (cookie id) for the user as mapped by the exchange for the buyer.' },
  { id: '[IFA_TYPE]', name: '[IFA_TYPE]', desc: 'The types of IFA are Device, Publisher (including apps), SSP and Session.' },
  { id: '[LANGUAGE]', name: '[LANGUAGE]', desc: 'Content language using ISO-639-1-alpha-2.' },
  { id: '[PLACEMENT_ID]', name: '[PLACEMENT_ID]', desc: 'Identifier for specific ad placement or ad tag that was used to initiate the auction' },
  { id: '[TITLE]', name: '[TITLE]', desc: 'Content title.' },
  { id: '[GPP]', name: '[GPP]', desc: 'Global Privacy Platform String' },
  { id: '[MIMES]', name: '[MIMES]', desc: 'Content MIME types supported' },
];

export const urlAttrsDSP = {
  '[DOMAIN]': 'domain',
  '[LOCATION_LON]': 'lon',
  '[LOCATION_LAT]': 'lat',
  '[REF_URL]': 'ref',
  '[APP_BUNDLE]': 'bundle',
  '[PAGE_URL]': 'page',
  '[WIDTH]': 'w',
  '[HEIGHT]': 'h',
  '[IFA]': 'ifa',
  '[STORE_URL]': 'store_url',
  '[APP_NAME]': 'name',
  '[DEVICE_TYPE]': 'devicetype',
  '[BIDFLOOR]': 'bidfloor',
  '[CONSENT]': 'consent',
  '[GDPR]': 'gdpr',
  '[API]': 'api',
  '[CARRIER]': 'carrier',
  '[MAX_DURATION]': 'maxduration',
  '[MIN_DURATION]': 'minduration',
  '[CB]': 'cb',
  '[UA]': 'ua',
  '[IP]': 'ip',
  '[NAME]': 'name',
  '[CCPA]': 'ccpa',
  '[GDPR_CONSENT]': 'gdpr_consent',
  '[USER_ID]': 'user_id',
  '[DEVICE_W]': 'device_w',
  '[DEVICE_H]': 'device_h',
};

export const connectionTypesNamesDSP = {
  0: 'RTB Endpoint URL',
  1: 'VAST Endpoint URL',
  3: 'JS Endpoint URL',
  4: 'PreBid Endpoint',
};

export const apiLinkValidationStatus = [
  { status: 'none', label: 'Unique link' },
  { status: 'none', label: 'URL structure' },
  { status: 'none', label: 'Contains data Macro' },
  { status: 'none', label: 'Test response is correct ' }
];

export const endpointValidationStatusItems = [
  { status: 'none', label: 'EP has a valid URL' },
  { status: 'none', label: 'EP is properly tied to an IP on DSP’s end' },
  { status: 'none', label: 'EP is tied to IP in the corresponding region' },
];

export const requiredFields = {
  companyId: 'Company',
  bidfloor: 'Bidfloor',
};

export const connectionTypesNames = {
  1: 'VAST Endpoint',
  0: 'RTB Endpoint',
  3: 'JS Endpoint',
  4: 'Prebid Endpoint',
  5: 'Prebid.js Endpoint'
};


export const sortableDSPTableColumns: string[] = [
  'name', 'id', 'bidqps', 'bidQPS', 'dsp_rcpm', 'qps', 'daylySpend', 'yesterdaySpend',
  'limitQPS', 'realQPS', 'spendLimit', 'fill_rate', 'win_rate',
  'valid_bid_rate', 'render_rate', 'total_bid_rate',
  'margin', 'dsp_ecpm'
];

export const sortableSSPTableColumns: string[] = [
  'name', 'id', 'bidqps', 'bidQPS', 'ssp_rcpm', 'qps', 'incoming_qps', 'daylySpend', 'yesterdaySpend',
  'limitQPS', 'realQPS', 'spendLimit', 'fill_rate', 'win_rate',
  'valid_bid_rate', 'render_rate', 'total_bid_rate',
  'margin', 'ssp_ecpm'
];


export const nativeVersionsItems = [
  { id: -1, name: 'All Native Versions' },
  { id: 1, name: '1.0' },
  { id: 2, name: '1.1' },
  { id: 3, name: '1.2' }
];

export const auctionTypesItems = [
  { id: 1, name: '1st price auction' },
  { id: 2, name: '2nd price auction' },
  { id: 3, name: 'Optimized model' }
];

export const allowTriggerItems = [
  { id: 0, name: 'Block' },
  { id: 1, name: 'Allow' }
];

export const connectionTypeEndpointLabelForDSP = {
  'rtb': 'Endpoint URL',
  'vast': 'VAST',
  'js': 'JS Tag',
  'prebid': 'Endpoint URL',
};

export const playerSizesItems = [
  { id: '0x250', name: 'X-small (< 250px)' },
  { id: '250x349', name: 'Small (250-349px)' },
  { id: '350x500', name: 'Medium (350-500px)' },
  { id: '501x799', name: 'Large (501-799px)' },
  { id: '800x9999', name: 'X-Large (≥ 800px)' }
];

export const pmPrebidSuspiciousIVTItems = [
  { id: 0, name: 'Allow' },
  { id: 1, name: 'Block' }
];

export const pmPrebidFraudIVTItems = [
  { id: 0, name: 'Allow' },
  { id: 1, name: 'Block' }
];

export const requiredFieldsForDSP = {
  limitQPS: 'QPS Limit',
  totalSpendLimit: '',
  jsTag: 'JS Tag',
};

export const connectorsItems = [
  { id: 1, name: 'Improve digital' },
  { id: 2, name: 'Rubicon' }
];

export const dspConnections = {
  rtb: 0,
  vast: 1,
  xml: 2,
  js: 3,
  prebid: 4,
};

export const vastConnectionsForDSP = {
  vastToAll: 0,
  vastToVast: 1,
  vastToRtb: 2
};

export const marginKeys: {
  min_margin: string;
  max_margin: string;
  margin: string;
} = {
  min_margin: 'Minimum Margin',
  max_margin: 'Maximum Margin',
  margin: 'Margin',
};


export const SKIP_ITEMS = [
  { id: 0, name: 'No' },
  { id: 1, name: 'Yes' },
];

export const STARTDELAY_ITEMS = [
  { id: 1, name: 'Mid-roll' },
  { id: 0, name: 'Pre-roll' },
  { id: -1, name: 'Generic Mid-roll' },
  { id: -2, name: 'Generic Post-roll' },
];

export const PLACEMENT_ITEMS = [
  { id: 1, name: 'In-stream' },
  { id: 2, name: 'In-Banner' },
  { id: 3, name: 'In-Article' },
  { id: 4, name: 'In-Feed' },
  { id: 5, name: 'Interstitial/Slider/Floating' },
];

export const PLCMT_ITEMS = [
  { id: 1, name: 'Instream' },
  { id: 2, name: 'Accompanying content' },
  { id: 3, name: 'Interstitial' },
  { id: 4, name: 'No Content/Standalone' },
];

export const POSITION_ITEMS = [
  { id: 1, name: 'Above the fold', desc: '', },
  { id: 2, name: 'DEPRECATED', desc: 'May or may not be initially visible depending on screen size/resolution.', },
  { id: 3, name: 'Below the fold', desc: '', },
  { id: 4, name: 'Header', desc: '', },
  { id: 5, name: 'Footer', desc: '', },
  { id: 6, name: 'Sidebar', desc: '', },
  { id: 7, name: 'Full Screen', desc: '', },
];

export const PLAYBACKMETHOD_ITEMS = [
  { id: 1, name: 'Page Load with Sound On' },
  { id: 2, name: 'Page Load with Sound Off by Default' },
  { id: 3, name: 'Click with Sound On' },
  { id: 4, name: 'Mouse-Over with Sound On' },
  { id: 5, name: 'Entering Viewport with Sound On' },
  { id: 6, name: 'Viewport with Sound Off by Default' },
];

export const PROTOCOLS_ITEMS = [
  { id: 1, name: 'VAST 1.0' },
  { id: 2, name: 'VAST 2.0' },
  { id: 3, name: 'VAST 3.0' },
  { id: 4, name: 'VAST 1.0 Wrapper' },
  { id: 5, name: 'VAST 2.0 Wrapper' },
  { id: 6, name: 'VAST 3.0 Wrapper' },
  { id: 7, name: 'VAST 4.0' },
  { id: 8, name: 'VAST 4.0 Wrapper' },
  { id: 9, name: 'DAAST 1.0' },
  { id: 10, name: 'DAAST 1.0 Wrapper' },
  { id: 11, name: 'VAST 4.1' },
  { id: 12, name: 'VAST 4.1 Wrapper' },
  { id: 13, name: 'VAST 4.2' },
  { id: 14, name: 'VAST 4.2 Wrapper' },
  { id: 15, name: 'VAST 4.3' },
  { id: 16, name: 'VAST 4.3 Wrapper' },
];

export const API_PROTOCOLS_ITEMS = [
  { id: 1, name: 'VPAID 1.0' },
  { id: 2, name: 'VPAID 2.0' },
  { id: 3, name: 'MRAID-1' },
  { id: 4, name: 'ORMMA' },
  { id: 5, name: 'MRAID-2' },
  { id: 6, name: 'MRAID-3' },
];

export const DEFAULT_MIMES_ITEMS = [
  { id: 'video/mp4', name: 'video/mp4' },
  { id: 'video/mpeg', name: 'video/mpeg' },
  { id: 'video/ogg', name: 'video/ogg' },
  { id: 'video/webm', name: 'video/webm' },
  { id: 'application/javascript', name: 'application/javascript' },
];


export const MIMES_AUDIO_ITEMS = [
  { id: 'audio/mp4', name: 'audio/mp4' },
  { id: 'audio/mpeg', name: 'audio/mpeg' },
  { id: 'audio/ogg', name: 'audio/ogg' },
  { id: 'audio/wav', name: 'audio/wav' },
];